import { render, staticRenderFns } from "./ScorecardSummary.vue?vue&type=template&id=f2370c7c"
import script from "./ScorecardSummary.vue?vue&type=script&lang=js"
export * from "./ScorecardSummary.vue?vue&type=script&lang=js"
import style0 from "./ScorecardSummary.vue?vue&type=style&index=0&id=f2370c7c&prod&soped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports